export default __webpack_public_path__ + "d94a5bbe86c9dffa19b6fd11b84357ab.webp";